<template>
  <div></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import collab from "../collab";

interface Folder {
  id: string;
  name: string;
}

export default defineComponent({
  setup() {
    const { data: folders } = collab.DpaIdCollabGraphqlUseFolders(true);
    return { folders };
  },
  watch: {
    folders(newVal: Folder[]) {
      if (newVal.length > 0) {
        this.$router.push({
          name: "folder",
          params: { folderId: newVal[0].id }
        });
      } else {
        this.$router.push({ name: "noFolders" });
      }
    }
  }
});
</script>
